import { Typography } from '@mui/material';
import React from 'react';

import { formatMoney } from '../../../../../../../../../lib/functions/utils';

const RowComponent = (props: any) => {
  const { label, value } = props;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="body1">
        <b>{label}:</b>
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </div>
  );
};

const productTypeMap = {
  traditional: 'Tradicional',
  earlyPayment: 'Pronto pago',
};

const OperationResume = (props: any) => {
  const {
    stakeholderName,
    stakeholderIdentifier,
    documents,
    productType,
    requestDate,
  } = props;

  return (
    <div>
      {stakeholderName && (
        <RowComponent label="Cliente" value={stakeholderName} />
      )}
      {stakeholderIdentifier && (
        <RowComponent label="Rut cliente" value={stakeholderIdentifier} />
      )}
      {documents && (
        <RowComponent
          label="Documentos seleccionados"
          value={documents.length}
        />
      )}
      {documents && (
        <RowComponent
          label="Monto total"
          value={formatMoney(
            documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
          )}
        />
      )}
      {productType && (
        <RowComponent
          label="Tipo de producto"
          value={productTypeMap[productType as keyof typeof productTypeMap]}
        />
      )}
      {requestDate && (
        <RowComponent label="Fecha de operación" value={requestDate} />
      )}
    </div>
  );
};

export default OperationResume;
